<div *ngIf="formGroup && salutations"
     [formGroup]="formGroup">

  <div class="row no-gutters mb-3">
    <div class="col-12" data-cy="mb-salutation-label">
      <span *ngIf="salutationOptional" class="mb-salutation-label">{{ salutationLabelKey | cxTranslate }}</span>
      <span *ngIf="!salutationOptional" class="mandatory-input-asterisk mb-salutation-label">{{ salutationLabelKey | cxTranslate }}</span>
    </div>
  </div>

  <div *ngIf="salutations"
       data-cy="mb-salutation-group"
       [ngClass]="[isFormDisabled ? 'mb-salutation-group-disabled' : '', 'row mb-salutation-group']">
    <div *ngFor="let salutation of salutations"
         class="col-12 col-sm-6 col-md-2 mb-input-salutation-margin-bottom">
      <input class="mb-salutation-radio-input"
             type="radio"
             [checked]="selectedSalutation?.code === salutation?.code"
             (change)="onSalutationChange(salutation)"
             [id]="salutation?.code"
             required
             [disabled]="isFormDisabled"/>
      <label [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'mb-salutation-value mb-custom-label']" [for]="salutation?.code">
        {{salutation?.name}}
      </label>
    </div>
    <mb-form-errors [control]="formGroup?.get(constants.TITLE_CODE)"
                    [prefix]="'formValidationErrors'"
                    class="col-12 pl-0">
    </mb-form-errors>
  </div>

</div>
